import React from "react";

function NotesOfRegisterDocument() {
  return <div>Notes of Register Document</div>;
}

export default NotesOfRegisterDocument;
